import React, { useMemo } from 'react'
import context from '@/context'
import {
  createLookupFilterCell,
  LookupCell,
  Column,
  DateCell, DateFilterCell
} from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'

export const StatusHistory = React.memo(function StatusHistory ({ dataSource }) {
  const { localize } = useLocalization()
  const defaultSort = useMemo(() => ([{ field: 'changeDate', dir: 'desc' }]), [])
  return (
    <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.StatusHistory}>
      <PropertyRenderer name='statusHistory' inputType='grid' dataSource={dataSource} readonly defaultSort={defaultSort}>
        <Column field='state' title={localize('Common.Status')}
          cell={LookupCell} filterCell={createLookupFilterCell(context.cache.getBankStates)} />
        <Column field='changeDate' title={localize('Common.ChangeDate')} filter='date' filterCell={DateFilterCell} cell={DateCell} />
        <Column field='approvalNumber' title={localize('Common.ApprovalNumber')} />
      </PropertyRenderer>
    </PermissionSectionProvider>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/statusHistory.js